import React from "react";

import { Grid, makeStyles } from "@material-ui/core";

import HeadroomPastTwelveMonths from "./HeadroomPastTwelveMonths";
import ProductCategoryFilter from "./ProductCategoryFilter";
import SalesByProduct from "./SalesByProduct";
import SalesByProductTitle from "./SalesByProductTitle";
import Sort from "./Sort";

const useStyles = makeStyles(theme => ({
    chartSortBtn: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        height: theme.spacing(11)
    },
}));

const RangeOverview: React.FC = () => {
    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <HeadroomPastTwelveMonths />
            </Grid>
            <Grid item xs={12}>
                <SalesByProductTitle />
            </Grid>
            <Grid item xs={6}>
                <ProductCategoryFilter />
            </Grid>
            <Grid item md={6} className={classes.chartSortBtn}>
                <Sort />
            </Grid>
            <Grid item xs={12}>
                <SalesByProduct />
            </Grid>
        </Grid>
    );

};

export default RangeOverview;
